<template>
    <div id="bp-listings" class="container-fluid">
        <div class="container">
            <div class="row">
                <h5 class="copy-heading-sub"><b>{{ component.content.label }}</b></h5>
                <h2 class="copy-heading" v-html="component.content.title"></h2>
            </div>
            <div class="row">

                <div :class="[ 'col-12 col-lg-6' ]" v-for="( listing, ind ) in component.listings.priority.data" :key="ind" v-if="component.listings.priority.data">

                    <listing_component :id="listing._id" :image="listing.images[0].thumbs['800x600']" :suburb="listing.address.suburb_or_town" :number="listing.address.street_number" :street="listing.address.street_name" :listingURL="listing.address.street_number + '-' + listing.address.street_name + '-' + listing.address.suburb_or_town"/>

                </div>

                <div :class="[ 'col-12 col-lg-6' ]" v-for="(listing, ind) in component.listings.data" :key="ind" >

                    <listing_component :id="listing._id" :image="listing.images[0].thumbs['800x600']" :suburb="listing.address.suburb_or_town" :number="listing.address.street_number" :street="listing.address.street_name" :listingURL="listing.address.street_number + '-' + listing.address.street_name + '-' + listing.address.suburb_or_town"/>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

    // dependencies
    import axios from "axios";
    import shuffle from 'lodash/shuffle';

    // load components
    import listing_component from "../global/listing-preview.vue";
    
    export default({
        name: "listings-component",
        components: {
            listing_component
        },
        data() {
            return {
                setDelay: 2000,
                component: {
                    content: {
                        label:  "Listings",
                        title:  "Our properties"
                    },
                    listings: {
                        priority: {
                            ids:    [ "3795548", "3795497", "3795442", "3500444" ],
                            data:   []
                        },
                        deleted:    {
                            ids:    [ "3595209", "3570684", "3755267", "15747324", "4267180" ],
                            data:   []
                        },
                        data:   []
                    }
                }
            }
        },
        methods: {

            // clear sessions storage
            clearStorage() {
                sessionStorage.setItem( "listingID", null );
            },
            
            // get listings
            agentListings() {
                let setAPIKey;
                axios.post( process.env.VUE_APP_URL, {
                    email:      process.env.VUE_APP_USER_EMAIL,
                    password:   process.env.VUE_APP_USER 
                })
                .then(function (response) {
                    setAPIKey = response.data.result;
                }).then(()=> {

                    fetch( process.env.VUE_APP_SEARCH, {
                        body: JSON.stringify(
                            {
                                //"limit": 4,
                                "extra_options": {
                                    "extra_fields": [
                                    "contract",
                                    "idealfors",
                                    "allowances",
                                    "events",
                                    "links",
                                    "bookings",
                                    "images",
                                    "floorplans",
                                    "tags",
                                    "features",
                                    "views",
                                    "advert_internet",
                                    "advert_brochure",
                                    "advert_stocklist",
                                    "rural",
                                    "documents",
                                    "subcategories",
                                    "meta",
                                    "cf.properties.*",
                                    "cf.listings.*"
                                    ],
                                    "search_arguments": {
                                        "extra_options": 
                                            {
                                                "include_unpublished": 0
                                            },
                                        "result_format": "website_overrides_applied"
                                    }
                                },
                                "criteria": [
                                    {
                                        "name": "listing.system_listing_state",
                                        "value":"current"
                                    }
                                ]
                            }
                        ),             
                        headers: {
                            "Accept": "application/json, text/javascript, */*; q=0.01",
                            "Authorization": "Bearer " + setAPIKey,
                            "Content-Type": "application/json",
                            "X-Api-Option": "use_status_codes=true,add_request_prefixes=true,use_strict_arguments=false,strip_response_prefixes=false"
                        },
                        method: "POST"
                    }).then(response => response.json())
                    .then( response => {

                        this.filterListings( response.result.rows );

                    });
                });
            },

            filterListings ( listings ) {

                // store returned listings JSON as a variable
                const getListings = listings
                const priorityIDs = this.component.listings.priority.ids;
                const deletedIDs = this.component.listings.deleted.ids;

                // loopn through returned listings
                getListings.forEach( listing => {

                    const getID = listing._id;

                    if( priorityIDs.includes( getID ) ) {

                        this.component.listings.priority.data.push( listing );

                        // shuffle listings
                        this.component.listings.priority.data = shuffle( this.component.listings.priority.data );


                    } else if( deletedIDs.includes( getID ) ) {

                        this.component.listings.deleted.data.push( listing );

                    } else {

                        this.component.listings.data.push( listing );

                        // shuffle listings
                        this.component.listings.data = shuffle( this.component.listings.data );

                    }

                })
                
            }

        },
        beforeMount() {
            this.clearStorage();
            this.agentListings();
        },
        mounted() {
           
        },
        created() {

        }
        
    });
</script>

<style lang="scss" scoped >
    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    #bp-listings {
        background-color:$white;
        padding-bottom:6em;
        padding-top:6em;
        position:relative;
        .copy-heading-sub {
            color:$color_main;
            font-weight: $font-weight-bold;
            margin-bottom:2em;
        }
        .copy-heading {
            color: $text;
            font-family:'IBM Plex Serif', serif;
            font-size: 3em;
            font-weight: $font-weight-bold;
            line-height: 1.15;
            margin-bottom:.5em;
        }
        #listingID_3755267 {
            display:no
        }
    }
</style>